// extracted by mini-css-extract-plugin
module.exports = {"flavorIcon":"TreeMenuWrapper_flavorIcon__34lcy","toggleIcon":"TreeMenuWrapper_toggleIcon__1PvJ9","active":"TreeMenuWrapper_active__w1JPs"};